import React from 'react';
import Comments from './Comments';
import { Context as CommentsContext } from './Context';
export default function CommentsWithContext(_ref) {
  var contentId = _ref.contentId,
    readOnly = _ref.readOnly,
    onPostComment = _ref.onPostComment,
    onDeleteComment = _ref.onDeleteComment,
    _ref$canSubscribe = _ref.canSubscribe,
    canSubscribe = _ref$canSubscribe === void 0 ? true : _ref$canSubscribe,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'DEFAULT' : _ref$size,
    totalCount = _ref.totalCount;
  return /*#__PURE__*/React.createElement(CommentsContext.Provider, {
    value: {
      contentId: contentId,
      onPostComment: onPostComment,
      onDeleteComment: onDeleteComment
    }
  }, contentId && /*#__PURE__*/React.createElement(Comments, {
    readOnly: readOnly,
    size: size,
    canSubscribe: canSubscribe,
    totalCount: totalCount,
    contentId: contentId,
    onPostComment: onPostComment
  }));
}